/** 位图字体允许的最大字号。 */
export const BITMAP_FONT_MAX_SIZE = 256

/**
 * 将字号限制在引擎与生成管线可接受范围内。
 * @param value 原始字号
 */
export function clampBitmapFontSize(value: number): number {
  if (!Number.isFinite(value)) return 30
  return Math.max(1, Math.min(BITMAP_FONT_MAX_SIZE, Math.round(value)))
}
